export default __webpack_public_path__ + "static/media/picsart.e849dc91.svg";